// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Закупівлі» (Procurement, ключ `procurement`, група `office`). */
export const procurementManifest: IModuleManifest = {
  key: 'procurement',
  group: 'office',
  slug: 'procurement',
  prefix: 'PRC',
  name: { en: 'Procurement', uk: 'Закупівлі' },
  entities: [
    { key: 'procurement', slug: 'procurement', name: { en: 'Procurement', uk: 'Закупівлі' }, main: true },
    { key: 'purchase_item', slug: 'purchase-item', name: { en: 'Purchase Items', uk: 'Елементи' }, main: false },
    { key: 'purchase_approval', slug: 'purchase-approval', name: { en: 'Purchase Approvals', uk: 'Погодження' }, main: false },
    { key: 'purchase_supplier', slug: 'purchase-supplier', name: { en: 'Purchase Suppliers', uk: 'Постачальники' }, main: false },
    { key: 'purchase_delivery', slug: 'purchase-delivery', name: { en: 'Purchase Deliveries', uk: 'Поставки' }, main: false },
    { key: 'purchase_status', slug: 'purchase-status', name: { en: 'Purchase Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/procurementSlice').then((m) => m.procurementSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
